import React from 'react';
import numeral from 'numeral';

function Number({ value }) {

    return (
        <small>
            {`(${numeral(value).format('0.[0]a')})`}
        </small>
    );
}

export default Number;


// WEBPACK FOOTER //
// ./src/components/Number.jsx